import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/homePage";
import Register from "./pages/register";
import GroupsSelect from "./pages/groupsSelect";
import LocationSelect from "./pages/locationSelect";
import "./styles/global.css"
import "./styles/sideBar.css"
import BookInfoPanel from "./pages/bookInfoPanel";
import BookAdmin from "./pages/bookInfoAdmin";
import RegistrationForm from "./pages/registration_new";
import Registration from "./pages/register_new";
import Test from "./pages/test";
import ClientPanel from "./pages/clientPanel";
import Lists from "./pages/lists";
import FreqPanel from "./pages/freq";
import FreqAdmin from "./pages/freqPanel";
import NewFreq from "./pages/newFreq";
import AddGroup from "./pages/newFreq";
import GroupsPanel from "./pages/groups";
import InstruFreq from "./pages/instruFreq";
import AdminDashboard from "./pages/adminDashboard";
import SideBar from "./components/sidebar";
import AdminGroups from "./pages/adminGroups";
import Profile from "./components/profile";
import Planner from "./pages/planner";
import PlanBooking from "./pages/planBooking";
import AdminFreq from "./pages/adminFreq";
import { AuthProvider } from "./components/authProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminPanel from "./pages/adminPanel";
import { useState } from "react";
import NotePad from "./pages/notePad";
import Declarations from "./pages/declarations";
import GalaReservation from "./pages/galaReservation";
import GalaAdmin from "./pages/gala";
import Gala from "./pages/gala";
import InitHall, { InitGala } from "./pages/galaInit";
import PanelChoose from "./pages/panelChoose";
import TicketSale from "./pages/ticketSale";
import AdminPurchases from "./pages/purchases";
import TicketPanel from "./pages/ticketsPanel";
import TicketDownload from "./components/ticketDownload";
import Archives from "./pages/archives.jsx"
import Waiters from "./pages/waiters.jsx";
import UserSideBar from "./components/userSideBar.jsx";
import Documentation from "./pages/documentation.jsx";
import GroupsAdmin from "./pages/groupsAdmin.jsx";
import MonthlyPayments from "./pages/monthlyPayments.jsx";
import OldProfile from "./components/oldProfile.jsx";
import InstructorMonthSessions from "./pages/instruCalc.jsx";
import Storage from "./pages/storage.jsx";
import Leads from "./pages/leads.jsx";
import Bills from "./pages/bills.jsx";
import GroupsPage from "./pages/groupEditor.jsx";
import Team from "./pages/team.jsx";
import Charts from "./pages/charts.jsx";
import GroupsManager from "./pages/groupsManager.jsx";
import GalaList from "./pages/galaList.jsx";
import GalaTours from "./pages/galaTours.jsx";
import CreateGalaSeats from "./pages/ticketAdd.jsx";
import Tickets2026 from "./pages/tickets2026.jsx";
import GalaAdminSeats from "./pages/ticketsAdmin.jsx";
import TicketsReservations from "./pages/ticketsReservations.jsx";
import TicketsSearcher from "./pages/ticketsSearcher.jsx";
import AgeTypeStats from "./pages/yearStat.jsx";
import GalaNoTicketsList from "./pages/ticketsPersonList.jsx";

function App() {

  const [sideOpen, setSideOpen] = useState(true);

  const toggleSidebar = () => setSideOpen(prev => !prev);

  return (
    <>
      <AuthProvider>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HomePage />
              </>
            }
          />
          <Route
            path="/rejestracja/:fid"
            element={
              <>
                <LocationSelect />
              </>
            }
          />
          <Route
            path="/rejestracja/:fid/:lid"
            element={
              <>
                <GroupsSelect />
              </>
            }
          />
          <Route
            path="/rejestracja/:fid/:lid/:gid"
            element={
              <>
                <Register />
              </>
            }
          />
          <Route
            path="/gala"
            element={
              <>
                <UserSideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                <Tickets2026/>
              </>
            }
          />
          <Route
            path="/rezerwacje"
            element={
              <>
                <UserSideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                <TicketsReservations/>
              </>
            }
          />
          <Route
            path="/gala-admin"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <GalaAdminSeats/>
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/gala-bilety"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <TicketsSearcher/>
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/gala-osoby"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <GalaNoTicketsList/>
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/ksiegowosc"
            element={
              <>
              <ProtectedRoute requiredRole={"admin"}> 
                <BookInfoPanel />
              </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/ksiegowosc-developer"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <GroupsManager />
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/lista-gali"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <GalaList />
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/gala-rozklad"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <GalaTours />
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/listy"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <Lists isToogle={sideOpen}/>
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/listy/:uid"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <Profile isToogle={sideOpen}/>
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/archiwum"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <Archives isToogle={sideOpen}/>
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/archiwum/:uid"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <OldProfile isToogle={sideOpen}/>
                </ProtectedRoute>
              </>
            }
          />
          <Route
            path="/oczekujacy"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <Waiters isToogle={sideOpen}/>
                </ProtectedRoute>
              </>
            }
          />
        <Route
            path="/ksiegowosc/admin"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <BookAdmin />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/planner/admin"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <PlanBooking />
                </ProtectedRoute>
              </>
            }
          />

          {/* <Route
            path="/wybor-panelu"
            element={
              <>
                <PanelChoose />
              </>
            }
          /> */}

          
          <Route
            path="/twoje-bilety"
            element={
              <>
                <TicketPanel />
              </>
            }
          />

          <Route
            path="/panel-klienta"
            element={
              <>
                <UserSideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                <ClientPanel />
              </>
            }
          />

          <Route
            path="/dokumentacja"
            element={
              <>
                <UserSideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                <Documentation />
              </>
            }
          />

          <Route
            path="/frekwencja"
            element={
              <>
                <ProtectedRoute requiredRole={"instructor"}> 
                  <InstruFreq />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/deklaracje"
            element={
              <>
                <ProtectedRoute requiredRole={"instructor"}> 
                  <Declarations />
                </ProtectedRoute>
              </>
            }
          />


          <Route
            path="/frekwencja-admin"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <AdminFreq isToogle={sideOpen}/>
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/planner"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <Planner isToogle={sideOpen}/>
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/panel-admina"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <AdminPanel isToogle={sideOpen}/>
                </ProtectedRoute>
              </>
            }
          />

          <Route path="/no-access" element={<HomePage />} />

          <Route
            path="/grupy"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <GroupsPanel />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/grupy/admin"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <GroupsAdmin />
                </ProtectedRoute>
              </>
            }
          />
          
          <Route
            path="/oplaty"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <MonthlyPayments />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/magazyn"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <Storage />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/leady"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <Leads />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/wiek"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <AgeTypeStats />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/rozliczenia"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <Bills />
                </ProtectedRoute>
              </>
            }
          />

         <Route
            path="/trenerzy"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <InstructorMonthSessions />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/kadra"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <Team />
                </ProtectedRoute>
              </>
            }
          />

          <Route
            path="/notatnik"
            element={
              <>
                <ProtectedRoute requiredRole={"admin"}> 
                  <SideBar isToogle={sideOpen} toogle={toggleSidebar}/>
                  <NotePad isToogle={sideOpen} />
                </ProtectedRoute>
              </>
            }
          />

          <Route path="/grupyzarzad" element={<GroupsPage />} />
          <Route path="/grupyzarzad/:groupId" element={<GroupsPage />} />

          {/* <Route
            path="/dashboard"
            element={
              <>
                <SideBar />
                <AdminDashboard />
              </>
            }
          /> */}

          {/* <Route
            path="/admin-grupy"
            element={
              <>
                <SideBar />
                <AdminGroups />
              </>
            }
          /> */}

          {/* <Route
            path="/finanse/podsumowanie"
            element={
              <>
                <SideBar />
                <AdminGroups />
              </>
            }
          />

          <Route
            path="/finanse/raporty"
            element={
              <>
                <SideBar />
                <AdminGroups />
              </>
            }
          />

          <Route
            path="/finanse/statystyki"
            element={
              <>
                <SideBar />
                <AdminGroups />
              </>
            }
          />

          <Route
            path="/finanse/rozliczenia"
            element={
              <>
                <SideBar />
                <AdminGroups />
              </>
            }
          /> */}

          <Route path="/register" element={<Registration />} />
          <Route path="/register/:facilityId" element={<Registration />} />
          <Route path="/register/:facilityId/:locationId" element={<Registration />} />
          <Route path="/register/:facilityId/:locationId/:groupId" element={<Registration />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;
